import { authClient } from "@platform/auth/client";
import { sessionMutationOptions } from "@platform/auth/session-transition.context";
import { useAuth } from "@platform/auth/context";
import { TenantExitAction } from "./tenant-exit-action";

export function DeleteTenant({ className }: { className?: string }) {
	const { can } = useAuth();

	return (
		<TenantExitAction
			namespace="tenant.delete"
			hidden={!can({ organization: ["delete"] })}
			run={(organizationId) =>
				authClient.organization.delete({ organizationId, fetchOptions: sessionMutationOptions })
			}
			className={className}
		/>
	);
}
